import { render, staticRenderFns } from "./TabPost.vue?vue&type=template&id=98f8970e&scoped=true&"
import script from "./TabPost.vue?vue&type=script&lang=js&"
export * from "./TabPost.vue?vue&type=script&lang=js&"
import style0 from "./TabPost.vue?vue&type=style&index=0&id=98f8970e&prod&lang=css&"
import style1 from "./TabPost.vue?vue&type=style&index=1&id=98f8970e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f8970e",
  null
  
)

export default component.exports